import $http from '@/config/http'
import { setHttpData ,doorman} from '@config/makeRequest'
import dataTable from '@config/dataTable'
import fa from "element-ui/src/locale/lang/fa";

/*
* lijing
*
* */
//获取服务器时间
export const getServerTime = () => {
  return new Promise((resolve, reject) => {
    $http.post('/', { domain: 'cdel', resourcePath: '+/server/time' })
      .then(res => {
        const { data } = res
        if (data.success) {
          resolve(data.result)
        } else {
          reject({ msg: '获取服务器时间失败' })
        }
      }).catch(() => {
      reject({ msg: '获取服务器时间失败' })
    })
  })
}

// 获取公匙
export const getPublicKey = () => {
  return new Promise((resolve, reject) => {
    $http.post('/common', {
      params: {
        time: (new Date).getTime()
      },
      domain: 'cdel',
      resourcePath: '+/key/public',
      platform: '',
      appType: '',
      appVersion: ''
    })
      .then(res => {
        const { data } = res
        if (data.success) {
          resolve(data.result.result)
        } else {
          reject({ msg: '获取公钥失败' })
        }
      })
      .catch(() => {
        reject({ msg: '获取公钥失败' })
      })
  })
}

//对外课程获取（通用）
export const getSiteCourseList = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/theme/getSiteCourses', params)
      .then(res => {
        if (res.success) {
          resolve(res.result.result)
        } else {
          reject({ msg: '课程信息获取失败' })
        }
      }).catch(() => {
      reject({ msg: '课程信息获取失败' })
    })
  })
}

//获取机考科目主题
export const getMoniExamTheme = (params, sid) => {
  return new Promise((resolve, reject) => {
    setHttpData('/theme/getMoniExamTheme', params, sid).then(res => {
      if (res.success) {
        let { result } = res.result
        resolve(result)
      } else {
        reject({ msg: '辅导数据获取失败' })
      }
    }).catch(() => {
      reject({ msg: '辅导数据获取失败' })
    })
  })
}

//获取是否有临时保存试卷
export const checkTempPaper = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/checkTempPaper', params)
      .then(res => {
        if (res.success) {
          const { result } = res.result
          resolve(result)
        } else {
          reject({ msg: '获取临时保存信息失败' })
        }
      }).catch(() => {
      reject({ msg: '获取临时保存信息失败' })
    })
  })
}


//获取是否有临时保存试卷---活动的临时保存检测
export const checkIsHasTempRecordActivityReq = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/m/checkIsHasTempRecordActivity', params)
    .then(res => {
      if (res.success) {
        const { result } = res.result
        resolve(result)
      } else {
        reject({ msg: '获取临时保存信息失败' })
      }
    }).catch(() => {
      reject({ msg: '获取临时保存信息失败' })
    })
  })
}

//检测是否已经做了，已做返回分数---活动
export const checkPaperViewIsDoneActivityReq = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/checkPaperViewIsDoneMidActivity', params)
    .then(res => {
      if (res.success) {
        const { result } = res.result
        resolve(result)
      } else {
        reject({ msg: '检测是否已做失败' })
      }
    }).catch(() => {
      reject({ msg: '检测是否已做失败' })
    })
  })
}

//获取四大对象
export const getAllInformation = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/paperCreate', params)
      .then(res => {
        if (res.success) {
          if(res.result.success) {
            const { result } = res.result
            let constructorDataList = dataTable.encodeData(result)
            resolve(constructorDataList)
          } else {
            if(res.result.errorCode === '-1' && res.result.errorMsg) {
              reject({ msg:res.result.errorMsg, errorCode:res.result.errorCode })
            } else {
              reject({ msg: '获取试卷信息失败' })
            }
          }
        } else {
          reject({ msg: '获取试卷信息失败' })
        }
      }).catch(() => {
      reject({ msg: '获取试卷信息失败' })
    })
  })
}

/*
* yuwenting
*
* */

//  获取考试记录(练习记录)列表
export const getRecordList = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/record/getRecords', params)
      .then(res => {
        let { result } = res.result
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '记录列表获取失败' })
        }
      }).catch(() => {
      reject({ msg: '记录列表获取失败' })
    })
  })
}

//  查看用户统计数据
export const quesAnalyStatistics = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/record/quesAnalyStatistics', params)
      .then(res => {
        let { result } = res.result
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '用户统计数据获取失败' })
        }
      }).catch(() => {
      reject({ msg: '用户统计数据获取失败' })
    })
  })
}

//  删除考试记录
export const deleteRecord = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/record/delete', params)
      .then(res => {
        let { result } = res.result
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '删除记录失败' })
        }
      }).catch(() => {
      reject({ msg: '删除记录失败' })
    })
  })
}

// 获取章节练习列表
export const getChapterList = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/chapter/getChapter', params)
      .then(res => {
        let { result } = res.result
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '列表获取失败' })
        }
      }).catch(() => {
      reject({ msg: '列表获取失败' })
    })
  })
}

// 获取章节练习题题型参数
export const getQuestionType = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/chapter/getQuestionType', params)
      .then(res => {
        let { result } = res.result
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '题型参数获取失败' })
        }
      }).catch(() => {
      reject({ msg: '题型参数获取失败' })
    })
  })
}

// 查看解析
export const quesAnaly = (params) => {
  return new Promise((resolve, reject) => {
    let resultData
    setHttpData('/record/getQuesAnaly', params)
    .then(res => {
      if (res.result.result.icode === '-1') {
        return resultData
      }
      let { result } = res.result
      if (res.success) {
        let constructorDataList = dataTable.encodeData(result, true)
        let newTypeShowMap = {}
        constructorDataList.quesShowList.forEach((item) => {
          if (Object.keys(newTypeShowMap).indexOf('sort' + item.relOrder) === -1) {
            newTypeShowMap['sort' + item.relOrder] = result.quesTypeShowMap[item.relOrder]
          }
        })
        constructorDataList.quesTypeShowMap = newTypeShowMap
        resolve(constructorDataList)
      } else {
        reject({ msg: '解析数据获取失败' })
      }
    }).catch(() => {
      reject({ msg: '解析数据获取失败' })
    })
  })
}

//提交试卷
export const savePaper = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/save',params)
    .then(res => {
      let { result } = res.result
      if (res.success) {
        if(res.result.success) {
          resolve(result)
        } else {
          if(res.result.errorCode === '-1' && res.result.errorMsg) {
            reject({ msg:res.result.errorMsg, errorCode:res.result.errorCode })
          } else {
            reject({ msg: '提交试卷失败' })
          }
        }

      } else {
        reject({ msg: '提交试卷失败' })
      }
    }).catch(() => {
      reject({ msg: '提交试卷失败' })
    })
  })
}

//临时保存
export const saveTemp = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/saveTemp',params)
    .then(res => {
      let { result } = res.result
      if (res.success) {
        resolve(result)
      } else {
        reject({ msg: '临时保存失败' })
      }
    }).catch(() => {
      reject({ msg: '临时保存失败' })
    })
  })
}

//章节练习组卷
export const paperCreateByChapter = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/chapter/paperCreateByChapter',params)
    .then(res => {
      let { result } = res.result
      if (res.success) {
        let constructorDataList = dataTable.encodeData(result)
        resolve(constructorDataList)
      } else {
        reject({ msg: '获取试卷信息失败' })
      }
    }).catch(() => {
      reject({ msg: '获取试卷信息失败' })
    })
  })
}

//章节练习重做数据
export const paperRedo = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/record/paperRedo',params)
    .then(res => {
      let { result } = res.result
      if (res.success) {
        let constructorDataList = dataTable.encodeData(result)
        resolve(constructorDataList)
      } else {
        reject({ msg: '获取重做数据失败' })
      }
    }).catch(() => {
      reject({ msg: '获取重做数据失败' })
    })
  })
}

//普通卷试卷根据特色展示内容接口
export const getPapaerViewCharacteristic = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/theme/getPapaerViewCharacteristic',params)
    .then(res => {
      let { result } = res.result
      if (res.success) {
        resolve(result)
      } else {
        reject({ msg: '获取特色内容数据失败' })
      }
    }).catch(() => {
      reject({ msg: '获取特色内容数据失败' })
    })
  })
}

//md5加密
// export const getPlayAuxiliaryUrl = params => {
//   return new Promise((resolve, reject) => {
//     setHttpData('/play/getPlayAuxiliaryUrl',params)
//     .then(res => {
//       let { result } = res.result
//       if (res.success) {
//         resolve(result)
//       } else {
//         reject({ msg: '获取加密视频地址失败' })
//       }
//     }).catch(() => {
//       reject({ msg: '获取加密视频地址失败' })
//     })
//   })
// }
//md5加密----新
export const getPlayAuxiliaryUrl = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/theme/getVdeioAddr',params)
    .then(res => {
      let { result } = res.result
      if (res.success) {
        resolve(result)
      } else {
        reject({ msg: '获取加密视频地址失败' })
      }
    }).catch(() => {
      reject({ msg: '获取加密视频地址失败' })
    })
  })
}


//获取试卷基本信息
export const moniexamQuestionTypes = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/moniexamQuestionTypes',params)
    .then(res => {
      let { result } = res.result
      if (res.success) {
        resolve(result)
      } else {
        reject({ msg: '获取试卷基本信息失败' })
      }
    }).catch(() => {
      reject({ msg: '获取试卷基本信息失败' })
    })
  })
}

/*
* baidandan
*
* */
//查看解析
export const getQuesAnaly = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/record/getQuesAnaly', params)
      .then(res => {
        let { result } = res.result
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '列表获取失败' })
        }
      }).catch(() => {
      reject()
    })
  })
}

//删除错题
export const updatePaperRecord = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/updatePaperRecord', params)
      .then(res => {
        let { result } = res.result
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '删除错题失败' })
        }
      }).catch(() => {
      reject({ msg: '删除错题失败' })
    })
  })
}

// 收藏题目
export const addFavoriteQues = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/addFavoriteQues', params)
      .then(res => {
        let { result } = res.result
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '收藏题目失败' })
        }
      }).catch(() => {
      reject({ msg: '收藏题目失败' })
    })
  })
}
//取消收藏
export const deleteFavoriteQues = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/deleteFavoriteQues', params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '取消收藏题目失败' })
        }
      }).catch(() => {
      reject({ msg: '取消收藏题目失败' })
    })
  })
}

export const aiScoringStatus = (bizID) =>
  $http.get(`//member.chinaacc.com/qzCloud/getPaperAnalysisByPaperIDBizID/-1/${bizID}`)
    .then(res => {
      const {success, result, errorMsg} = res.data;
      if (success && result) {
        if (result.commonInfo) {
          const {isAI, AIReviewedStatus} = result.commonInfo;
          return !!(isAI === 1 && (AIReviewedStatus === "1"||AIReviewedStatus === 1));
        }
        throw "commonInfo is null";
      }
      throw errorMsg || "err";
    })

// 普华永道获取是否在考试时间内、做题次数
export const getPwcExamInfo=(params)=>{
  return doorman('+/qzCloud/getExamDateAndExamNum', params);
}

// 获取解析
export const getPaperAnalysisBySerialID=(params)=>{
  return doorman('+/a-kjwx/t-qz/app/getPaperAnalysisBySerialID', params);
}

// 查询用户购买题库会员状态及辅导科目是否支持题库会员商品
export const getTikuUserVipFlag=(params)=>{
  return doorman('+/m-sel/w-sale/saleapi/getTikuUserVipFlag', params);
}

// 题库会员权益
export const getIconsApi=(params)=>{
  return doorman('+/a-wx/a-ai/homepageapi/getIconsApi', params);
}

// 保存用户行为(不校验sid登录)
export const saveUserActionRecord=(params)=>{
  return doorman('~/a-wx/z-ai/school/action/saveUserActionRecord', params);
}



